import { render } from "./WorkoutFilter.vue?vue&type=template&id=5dda7c6b&scoped=true"
import script from "./WorkoutFilter.vue?vue&type=script&lang=js"
export * from "./WorkoutFilter.vue?vue&type=script&lang=js"

import "./WorkoutFilter.vue?vue&type=style&index=0&id=5dda7c6b&scoped=true&lang=scss"

import exportComponent from "/Users/lolo/projects/mygpsworkouts-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dda7c6b"]])

export default __exports__